import { render, staticRenderFns } from "./TrangQuanLyThietBi.vue?vue&type=template&id=b2880d22&scoped=true&"
import script from "./TrangQuanLyThietBi.vue?vue&type=script&lang=js&"
export * from "./TrangQuanLyThietBi.vue?vue&type=script&lang=js&"
import style0 from "./TrangQuanLyThietBi.vue?vue&type=style&index=0&id=b2880d22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2880d22",
  null
  
)

export default component.exports